/** @file Shared press of translate/rotate/scale: gizmo hit, else pick-and-drag a bone, else a marquee. */
import { gizmoHandles } from '@pose2d/editor-geometry/gizmoHandles';
import { hitGizmo } from '@pose2d/editor-geometry/hitGizmo';
import type { GizmoPart, GizmoTool } from '@pose2d/editor-geometry/types';
import { pickAt } from '../../panels/viewport/pickAt';
import type { ToolContext, ToolGesture, ViewportPointer } from '../../panels/viewport/viewportTypes';
import { updateSelection } from '../../stores/updateSelection';
import { marqueeGesture } from '../select/marqueeGesture';
import { editTargetOf, type EditTarget } from './editTargetOf';
import { gizmoFrame } from './gizmoFrame';
import { topSelected } from './topSelected';

/** What a gesture starts from. */
export interface GestureStart { ctx: ToolContext; edit: EditTarget; bones: number[]; part: GizmoPart; press: ViewportPointer }

const DEFAULT_PART: Readonly<Record<GizmoTool, GizmoPart>> = { translate: 'free', rotate: 'ring', scale: 'uniform' };

/** A pick replaces the selection with the picked bone and drags it with the tool's default part. */
export function transformPress(ctx: ToolContext, p: ViewportPointer, tool: GizmoTool, start: (g: GestureStart) => ToolGesture): ToolGesture | null {
  const edit = editTargetOf(ctx);
  if (edit === null) return null;
  const selected = topSelected(ctx, ctx.selection.bones);
  const part = selected.length === 0 ? null : hitGizmo(gizmoHandles(tool, gizmoFrame(ctx, selected, tool)), p.sx, p.sy);
  if (part !== null) return start({ ctx, edit, bones: selected, part, press: p });
  const hit = pickAt(ctx, p.sx, p.sy);
  if (hit.bone < 0) return marqueeGesture(ctx, p);
  const id = ctx.maps.boneIds[hit.bone] ?? '';
  updateSelection({ bones: [id], slots: [] }, 'replace');
  const bones = topSelected(ctx, [id]);
  return bones.length === 0 ? null : start({ ctx, edit, bones, part: DEFAULT_PART[tool], press: p });
}
